import { AuthMethod } from '../../../account-window/parts/auth-method';
import { LinkAuthMethodStrategy, LinkAuthMethodStrategyConstructor } from './link-auth-method-strategy.inteface';
import { LinkAuthMethodAppleIdStrategy } from './link-auth-method-apple-id.strategy';
import { LinkAuthMethodEmailStrategy } from './link-auth-method-email.strategy';
import { LinkAuthMethodFbStrategy } from './link-auth-method-fb.strategy';
import { LinkAuthMethodGoogleStrategy } from './link-auth-method-google.strategy';
import { getHubApi } from '../../../general/modules/accountServiceApi/getAccountServiceApi';

const linkAuthMethodStrategies = new Map<AuthMethod, LinkAuthMethodStrategyConstructor>();
linkAuthMethodStrategies.set(LinkAuthMethodAppleIdStrategy.authMethod, LinkAuthMethodAppleIdStrategy);
linkAuthMethodStrategies.set(LinkAuthMethodEmailStrategy.authMethod, LinkAuthMethodEmailStrategy);
linkAuthMethodStrategies.set(LinkAuthMethodFbStrategy.authMethod, LinkAuthMethodFbStrategy);
linkAuthMethodStrategies.set(LinkAuthMethodGoogleStrategy.authMethod, LinkAuthMethodGoogleStrategy);

export function getLinkAuthMethodStrategy(authMethod: AuthMethod): LinkAuthMethodStrategy {
    const Strategy = linkAuthMethodStrategies.get(authMethod);

    if (!Strategy) {
        throw new Error(`No strategy found for auth method: ${authMethod}`);
    }

    const hubApi = getHubApi();

    return new Strategy(hubApi);
}
